// Persian and Arabic-Indic digits
const FARSI_DIGITS: string[] = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']
const ARABIC_INDIC_DIGITS: string[] = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩']

type Nullable = string | number | null | undefined
    
function isNumeric(value: any): boolean {
    return typeof value === 'number' ||
        (typeof value === 'string' && value.trim() !== '' && /^[+-]?\d+(\.\d+)?$/.test(value))
}

export function convert_to_fa(number: Nullable): string {
    const n = number == null ? '' : String(number)
    // Replace only ASCII digits 0-9 with Persian digits
    return n.replace(/\d/g, d => FARSI_DIGITS[Number(d)])
}

export function farsi_number(number: Nullable, groupSeparator = true): Nullable {
    // preserve null/undefined as-is so callers can decide how to display missing values
    if (number == null) return number

    // only format numeric strings and numbers
    if (!isNumeric(number)) return number

    const raw = String(number)
    // parse as a number — Number preserves decimals while parseInt would drop them
    const num = Number(number)
    if (!isFinite(num)) return number

    // determine how many decimal digits to preserve based on input string when possible
    const hasDecimal = raw.includes('.')
    let formatted: string
    if (groupSeparator) {
        const options: Intl.NumberFormatOptions = {}
        if (hasDecimal) {
            const decimals = raw.split('.')[1] || ''
            // keep the same number of fraction digits as the input when possible
            options.minimumFractionDigits = decimals.length
            options.maximumFractionDigits = decimals.length
        }
        // use en-US locale for predictable separators (comma for thousands, dot for fraction)
        formatted = num.toLocaleString('en-US', options)
    } else {
        formatted = hasDecimal ? num.toString() : String(Math.trunc(num))
    }

    // finally convert ASCII digits to Persian digits
    return convert_to_fa(formatted)
}

export function convert_to_en(number: Nullable): string {
    const n = number == null ? '' : String(number)
    // replace Persian digits
    let out = n.replace(new RegExp(FARSI_DIGITS.join('|'), 'g'), d => FARSI_DIGITS.indexOf(d).toString())
    // replace Arabic-Indic digits too (٠١٢..)
    out = out.replace(new RegExp(ARABIC_INDIC_DIGITS.join('|'), 'g'), d => ARABIC_INDIC_DIGITS.indexOf(d).toString())
    return out
}